import React, { useState, useEffect } from 'react';
import { FaPlusCircle, FaTrash, FaEdit } from 'react-icons/fa';
import { collection, getDocs, doc, deleteDoc, updateDoc } from 'firebase/firestore';
import {  firestore } from '../../backend/firebaseConfig';
import CreateAdminForm from './CreateAdminForm';
import Sidebar from '../SidebarInAdminPanel/Sidebar';
import EditAdminForm from './editAdminForm'; // Assuming you have this component

const AdminManagementPage = () => {
  const [admins, setAdmins] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editingAdmin, setEditingAdmin] = useState(null);

  useEffect(() => {
    fetchAdmins();
  }, [showCreateForm, editingAdmin]);

  const fetchAdmins = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, 'admins'));
      const adminsArray = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAdmins(adminsArray);
    } catch (error) {
      console.error("Error fetching admins:", error.message);
    }
  };

  const handleDelete = async (id) => {
    try {
    
      await deleteDoc(doc(firestore, 'admins', id));
      fetchAdmins(); // Re-fetch the admins after deletion
    } catch (error) {
      console.error("Error deleting admin:", error.message);
    }
  };

  
  const handleEdit = async (id, data) => {
    try {
      await updateDoc(doc(firestore, 'admins', id), data);
      fetchAdmins();
    } catch (error) {
      console.error("Error updating admin:", error.message);
    }
  };

  return (
    <div className="flex bg-gradient-to-r from-[#0AD1C8] to-[#073235] dark:from-[#0AD1C8] dark:to-[#073235]">
      <Sidebar />
      <div className=" flex-1 p-8">
        <h1 className="text-4xl font-bold mb-8 text-white">Admin Management</h1>
        <button
          onClick={() => setShowCreateForm(true)}
          className="mb-6 bg-[#002D74] hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-xl inline-flex items-center">
          <FaPlusCircle />
          <span className="ml-2">Create Admin</span>
        </button>
        <div className="bg-white p-6 rounded-xl shadow-md">
          <table className="min-w-full leading-normal">
            <thead>
              <tr>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
                  Email
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
                  Phone
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {admins.map(admin => (
                <tr key={admin.id}>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-lg">
                    {admin.name}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-lg">
                    {admin.email}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-lg">
                    {admin.phone}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-lg">
                    <button onClick={() => handleDelete(admin.id)} className="text-red-500 hover:text-red-700 mr-3">
                      <FaTrash className='text-lg' />
                    </button>
                    <button onClick={() => setEditingAdmin(admin)} className="text-green-500 hover:text-green-700">
                      <FaEdit className='text-lg'  />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {showCreateForm && (
          <CreateAdminForm setShowCreateForm={setShowCreateForm} />
        )}
        {editingAdmin && (
          <EditAdminForm admin={editingAdmin} setEditingAdmin={setEditingAdmin} handleEdit={handleEdit} />
        )}
      </div>
    </div>
  );
};

export default AdminManagementPage;
